import { render } from "./renderless-assessment-panel.vue?vue&type=template&id=b98ccde4&ts=true"
import script from "./renderless-assessment-panel.vue?vue&type=script&lang=ts"
export * from "./renderless-assessment-panel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__